export default "__VITE_ASSET__B0$qOVEf__"